import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const OpentableIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props}>
    <path
      d="M19.291 7.291A8.709 8.709 0 0 0 10.582 16a8.709 8.709 0 1 0 8.709-8.709Zm0 10.886A2.16 2.16 0 0 1 17.114 16a2.16 2.16 0 0 1 2.177-2.177A2.16 2.16 0 0 1 21.468 16c0 1.164-1.012 2.177-2.177 2.177ZM4.001 16a2.16 2.16 0 0 1 2.176-2.177A2.16 2.16 0 0 1 8.355 16a2.16 2.16 0 0 1-2.178 2.177C4.962 18.177 4 17.164 4 16Z"
      fill={preserveColor ? "#DA3743" : undefined}
    />
  </BaseIcon>
);
